export enum ApplicationActionType {
    Review = 0,
    LostOrRecycle = 1,
    AppraisalOrder = 2,
    AppraisalReceive = 3,
    AppraisalReview = 4,
    ConvertToLoan = 5,
    Rollback = 6,
    AppraisalView = 7,
    AppraisalNotes = 9,
    ChangeLoanType = 10,
    Restore = 11,
    DeleteOrMoveProperties = 12,
    Summary = 13,
    AuditHistory = 14,
    SwapPrincipal = 15,
    ApplicationFiles = 16,
}
